import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';

import { EcsaMaterialModule } from './material-module';
import { HighchartsChartModule } from 'highcharts-angular';

import { TurnoutByDistrictComponent } from './components/ha/turnout-by-district/turnout-by-district.component';
import { FirstPreferenceGraphComponent } from './components/ha/first-preference-graph/first-preference-graph.component';
import { FirstPreferenceTableComponent } from './components/ha/first-preference-table/first-preference-table.component';
import { HemicycleGraphComponent } from './components/ha/hemicycle-graph/hemicycle-graph.component';
import { TwoCPTableComponent } from './components/ha/two-cp-table/two-cp-table.component';
import { CountProgressTableComponent } from './components/ha/count-progress-table/count-progress-table.component';
import { LeadingCandidateChartComponent } from './components/ha/leading-candidate-chart/leading-candidate-chart.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FirstPreferenceByPlaceAndVoteTypeComponent } from './components/ha/first-preference-by-place-and-vote-type/first-preference-by-place-and-vote-type.component';
import { TwoCpByPlaceAndVoteTypeComponent } from './components/ha/two-cp-by-place-and-vote-type/two-cp-by-place-and-vote-type.component';
import { DistributionOfPreferencesComponent } from './components/ha/distribution-of-preferences/distribution-of-preferences.component';
import { ErrorHandlerService } from './services/errorHandlerService';
import { MyMonitoringService } from './services/logging.service';
import { NavigationComponent } from './components/navigation/navigation.component';
import { PageHaSummaryComponent } from './components/page-ha-summary/page-ha-summary.component';
import { PageHaDistrictComponent } from './components/page-ha-district/page-ha-district.component';
import { PageLcSummaryComponent } from './components/page-lc-summary/page-lc-summary.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { PageLoadingComponent } from './components/page-loading/page-loading.component';
import { ExpandedMapDialogComponent } from './components/expanded-map-dialog/expanded-map-dialog.component';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { LcQuotaWonTableComponent } from './components/lc/lc-quota-won-table/lc-quota-won-table.component';
import { LcCountProgressTableComponent } from './components/lc/lc-count-progress-table/lc-count-progress-table.component';
import { LcTurnoutByDistrictComponent } from './components/lc/lc-turnout-by-district/lc-turnout-by-district.component';
import { LcVotesWonGraphComponent } from './components/lc/lc-votes-won-graph/lc-votes-won-graph.component';
import { LcVotesWonTableComponent } from './components/lc/lc-votes-won-table/lc-votes-won-table.component';
import { PartiesCurrentlyLeadingComponent } from './components/ha/parties-currently-leading/parties-currently-leading.component';
import { PartiesCurrentlyLeadingTableComponent } from './components/ha/parties-currently-leading-table/parties-currently-leading-table.component';
import { PartiesCurrentlyLeadingChartComponent } from './components/ha/parties-currently-leading-chart/parties-currently-leading-chart.component';
import { FirstPreferenceByPlaceComponent } from './components/ha/first-preference-by-place/first-preference-by-place.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { VoteDistributionPdfComponent } from './components/ha/vote-distribution-pdf/vote-distribution-pdf.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CountDownComponent } from './components/count-down/count-down.component';
import { AppRoutingModule } from './AppRoutingModule';
import { TestLiveComponent } from './components/test-live/test-live.component';
import { DatePipe, DecimalPipe } from '@angular/common';
import { NavigationLGEComponent } from './components/navigation-lge/navigation-lge.component';
import { PageLgeResultsComponent } from './components/page-lge-results/page-lge-results.component';
import { SideMenuLgeComponent } from './components/side-menu-lge/side-menu-lge.component';
import { PageLgeResultsPhoneComponent } from './components/page-lge-results-phone/page-lge-results-phone.component';
import { LgeElectionResultsComponent } from './components/lge/lge-election-results/lge-election-results.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatIconModule } from '@angular/material/icon';
import { DistrictSuccessfulCandidateComponent } from './components/ha/district-successful-candidate/district-successful-candidate.component';
import { LcCandidateElectedTableComponent } from './components/lc/lc-candidate-elected-table/lc-candidate-elected-table.component';
import { LcHemicycleGraphComponent } from './components/lc/lc-hemicycle-graph/lc-hemicycle-graph.component';
import { DistrictHeaderCardComponent } from './components/ha/district-header-card/district-header-card.component';
import { EditableContentComponent } from './components/editable-content/editable-content.component';
import { DistrictEssentialDataCardComponent } from './components/ha/district-essential-data-card/district-essential-data-card.component';
import { SeatsWonComparisonTableComponent } from './components/ha/seats-won-comparison-table/seats-won-comparison-table.component';

@NgModule({
  declarations: [
    AppComponent,
    TurnoutByDistrictComponent,
    FirstPreferenceGraphComponent,
    FirstPreferenceTableComponent,
    HemicycleGraphComponent,
    TwoCPTableComponent,
    CountProgressTableComponent,
    LeadingCandidateChartComponent,
    FirstPreferenceByPlaceAndVoteTypeComponent,
    TwoCpByPlaceAndVoteTypeComponent,
    DistributionOfPreferencesComponent,
    NavigationComponent,
    PageHaSummaryComponent,
    PageHaDistrictComponent,
    PageLcSummaryComponent,
    SideMenuComponent,
    PageLoadingComponent,
    ExpandedMapDialogComponent,
    LcQuotaWonTableComponent,
    LcCountProgressTableComponent,
    LcTurnoutByDistrictComponent,
    LcVotesWonGraphComponent,
    LcVotesWonTableComponent,
    PartiesCurrentlyLeadingComponent,
    PartiesCurrentlyLeadingTableComponent,
    PartiesCurrentlyLeadingChartComponent,
    FirstPreferenceByPlaceComponent,
    TwoCpByPlaceAndVoteTypeComponent,
    VoteDistributionPdfComponent,
    CountDownComponent,
    TestLiveComponent,
    NavigationLGEComponent,
    PageLgeResultsComponent,
    SideMenuLgeComponent,
    PageLgeResultsPhoneComponent,
    LgeElectionResultsComponent,
    DistrictSuccessfulCandidateComponent,
    LcCandidateElectedTableComponent,
    LcHemicycleGraphComponent,
    DistrictHeaderCardComponent,
    EditableContentComponent,
    DistrictEssentialDataCardComponent,
    SeatsWonComparisonTableComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    EcsaMaterialModule,
    MatCardModule,
    MatIconModule,
    HighchartsChartModule,
    NgxImageZoomModule,
    PdfViewerModule,
    MatTooltipModule,
  ],
  providers: [
    MyMonitoringService,
    DatePipe,
    DecimalPipe,
    // ErrorHandlerService,
    // { provide: ErrorHandler, useClass: ErrorHandlerService },
    // { provide: LOCALE_ID, useValue: "en-au" }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
